(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('VarietalDetailReportController', VarietalDetailReportController);

	VarietalDetailReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash', '$state'];

	function VarietalDetailReportController($window, WineRepository, $log, lodash, $state){

		/* jshint validthis: true */
		var self = this;

		self.wines = [];

		self.report = {
			groups: [],
			totals: {}
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.title = $state.current.data.title;

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.print = print;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){

			WineRepository.all()
				.then(function(wineEntities){

					if (wineEntities.length > 0){

						self.report.tableHeaders = [
							'Wine',
							'Location',
							'Size',
							'Bottles',
							'Average&nbsp;Cost',
							'Value',
							'Gain&nbsp;/&nbsp;Loss'
						];

						// add only those in the cellar
						lodash.forEach(wineEntities, function(wine) {
							if (wine.cellar.qty > 0) {
								self.wines.push(wine);
							}
						});

						var totalWines = self.wines.length;

						var totalBottles = WineRepository.getTotalCellarBottleCount(wineEntities);

						// by producer
						var winesGrouped = lodash.groupBy(self.wines, function(w) {
							return (w.varietal && w.varietal.name) ? lodash.capitalize(w.varietal.name.toLowerCase()) : '<em>Unknown</em>';
						});

						var keyName = 'Producer';
						var keyNamePlural = keyName + 's';

						// initialize totals
						var grandTotals = {
							bottles: totalBottles,
							value: 0,
							groupCount: Object.keys(winesGrouped).length,
							wines:  totalWines
						};

						lodash.forEach(winesGrouped, function(wines, groupName) {
							// count bottles for grouping, start at 0
							var totalGroupBottles = lodash.reduce(wines, function(total, wine) {
								return total + wine.cellar.qty;
							}, 0);

							// total value for grouping
							var totalGroupValue = lodash.sum(wines, function(wine) {
								var value = (wine.cellar && wine.cellar.value) ? parseFloat(wine.cellar.value) : 0;
								return (value > 0) ? value * wine.cellar.qty : 0;
							});
							// update grand total value
							grandTotals.value += totalGroupValue;

							var formattedWines = [];

							lodash.forEach(wines, function(wine) {
								var varietal = (wine.varietal && wine.varietal.name) ? wine.varietal.name + ' ' : '';
								var category = (wine.category && wine.category.name) ? wine.category.name : '';
								var type = varietal + category;

								var avgPurchasePrice = wine.avgPurchasePrice();
								var avgPurchasePriceFloat = $window.numeral(avgPurchasePrice);

								var valueGainFormatted = wine.getRelativeGainPercentFormatted(avgPurchasePriceFloat);
								var valueGainClass = wine.getValueGainClass(avgPurchasePriceFloat);

								// data we want to display on a single wine
								formattedWines.push({
									name: wine.getFullName(),
									appelation: wine.getFullAppellation(),
									type: type,
									location: wine.cellar.location,
									size: wine.bottleSize.name,
									qty: wine.cellar.qty,
									avgPurchasePrice: avgPurchasePrice,
									value: $window.numeral(wine.cellar.value).format('$0,0[.]00'),
									gain: valueGainFormatted,
									gainClass: valueGainClass
								});
							});

							self.report.groups.push({
								groupName: groupName,
								bottles: totalGroupBottles,
								value: $window.numeral(totalGroupValue).format('$0,0[.]00'),
								wines: formattedWines
							});

						});

						self.report.totals = [
							// 'GroupName / Wine',
							'Total ' + keyNamePlural + ': ' + grandTotals.groupCount + '<br/>Total wines: ' + grandTotals.wines,
							// 'Location'
							null,
							// 'Size',
							null,
							// 'Bottles',
							grandTotals.bottles,
							// 'Average Cost',
							null,
							// 'Value',
							$window.numeral(grandTotals.value).format('$0,0[.]00'),
							// 'Gain / Loss'
							null
						];

						return true;
					}

					return false;

				}).catch(function(err){
					$log.debug('Error getting wines', err);
				});

		}

		function print(){
			return $window.print();
		}
	}

})();
